import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "lucide-react";
import { useDateRange } from "@/contexts/DateRangeContext";

export function DateRangePicker() {
  const { dateRange, setDateRange, presets, formatDate } = useDateRange();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="gap-2" data-testid="date-range-picker">
          <Calendar className="h-4 w-4" />
          <span className="text-sm">
            {formatDate(dateRange.from)} — {formatDate(dateRange.to)}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2" align="end">
        <div className="flex flex-col gap-1">
          {presets.map((preset) => (
            <Button
              key={preset.label}
              variant="ghost"
              size="sm"
              className="justify-start text-sm"
              data-testid={`date-preset-${preset.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => {
                setDateRange(preset.getValue());
                setOpen(false);
              }}
            >
              {preset.label}
            </Button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
